import {Box, styled, Typography} from '@mui/material';

export const StyledWrapper = styled(Box)(({theme}) => ({
  height: theme.spacing(4.5),
  width: '100%',
  display: 'flex',
  flexGrow: 1,
  alignItems: 'flex-end',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  overflow: 'hidden'
}));

export const StyledImageWrapper = styled(Box)(({theme}) => ({
  width: 'auto',
  display: 'flex',
  alignItems: 'flex-end',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  overflow: 'hidden',
  height: theme.spacing(4.5)
}));

export const StyledImage = styled('img')(() => ({
  maxWidth: '100%',
  maxHeight: '100%'
}));

export const StyledBadgeWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1),
  minWidth: 0,
  borderRadius: theme.spacing(0.5),
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.25),
  height: theme.spacing(3.25),
  columnGap: theme.spacing(0.5)
})) as typeof Box;

export const PromoTagWrapper = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(0.5),
  height: '28px',
  display: 'inline-flex',
  border: '1px solid #E8E8E8',
  borderRadius: theme.spacing(1),
  alignItems: 'center',
  overflow: 'hidden'
})) as typeof Box;

export const PromoTagContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  borderRight: '1px solid #E8E8E8',
  paddingRight: theme.spacing(1.5),
  overflow: 'hidden'
})) as typeof Box;

export const PromoTagImage = styled('img')(({theme}) => ({
  marginLeft: theme.spacing(1.5),
  marginRight: theme.spacing(1.5),
  width: '24px',
  height: '24px',
  borderRadius: theme.spacing(2),
  flex: '0 0 auto'
}));

export const PromoTagText = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: 600,
  color: '#000000',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flex: '1 1 auto', // Allow text to grow and shrink as needed
  minWidth: 0 // Allow text to shrink below its content size
})) as typeof Typography;

export const PromoTagCount = styled(Typography)(({theme}) => ({
  color: theme.palette.common.black,
  fontSize: theme.spacing(1.5),
  fontWeight: 600,
  paddingLeft: theme.spacing(0.75),
  paddingRight: theme.spacing(1),
  flex: '0 0 auto', // Prevent count from shrinking or growing
  whiteSpace: 'nowrap' // Prevent wrapping
})) as typeof Typography;

export const StyledBadgeContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  overflow: 'hidden',
  gap: theme.spacing(1),
  flexGrow: 1,
  lineHeight: theme.spacing(2),
  fontSize: theme.spacing(1.5),
  color: theme.palette.common.black,
  width: '100%',
  '&.isProductCardV2': {
    border: `${theme.spacing(0.125)} solid ${theme.palette.grey[100]}`,
    borderRadius: theme.spacing(0.75)
  }
})) as typeof Box;

export const StyledBadgeCountWrapper = styled(Box)(({theme}) => ({
  textAlign: 'center',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  width: theme.spacing(2.5),
  height: theme.spacing(2.5),
  fontSize: theme.spacing(1.25),
  fontWeight: 600,
  '&.isProductCardV2': {
    width: theme.spacing(3.5),
    fontSize: theme.spacing(1.5)
  }
})) as typeof Box;

export const StyledIconWrapper = styled(Box)(() => ({
  display: 'flex'
})) as typeof Box;

export const StyledBadgeTextWrapper = styled(Box)(() => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
})) as typeof Box;
